import React, { Component } from 'react';
import * as CookieService from '../CookieService';
import * as $ from 'jquery';
import SDIConstants from '../SDIConstants';
import { withTranslation, Trans } from 'react-i18next'
import Select from 'react-select';
import * as MenuAction from '../actions/MenuAction';
import * as ManageFormAction from '../actions/ManageFormAction';
import ManageFormStore from '../stores/ManageFormStore';
import ReactPaginate from 'react-paginate';
import swal from 'sweetalert';
let currentPagePath;
class ManageFormComponent extends Component {
    constructor(props) {
        super(props);
        this.bindForm = this.bindForm.bind(this);
        this.viewForm = this.viewForm.bind(this);
        this.saveFormNameResponse = this.saveFormNameResponse.bind(this);
        this.state = {
            formDetails: [], duplicateformDetails: [],
            isFavorited: false, cloneQues: [], cloneOptions: [], cloneDetail: [], pageNo: "1", pageCount: 0, isSearch: false, filteredDetail: [], searchval: "",

            isAddText: true, isAddImage: false, addLabel: "", addDesc: "", attachment: []
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)

        this.pageLoad()
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        ManageFormAction.getCurrentFavPage(getFavPageBO);
        ManageFormStore.on('formPageLoadResponse', this.pageLoadResponse);
        ManageFormStore.on('deleteFormResponse', this.deleteFormResponse);
        ManageFormStore.on('saveFormNameResponse', this.saveFormNameResponse);
        ManageFormStore.on('currFav', this.loadFavPageResponse);
        ManageFormStore.on('insertFav', this.updateFavPageResponse);
        ManageFormStore.on('cloneFormResponse', this.cloneFormResponse);
    }
    componentWillUnmount() {
        ManageFormStore.removeListener('formPageLoadResponse', this.pageLoadResponse);
        ManageFormStore.removeListener('deleteFormResponse', this.deleteFormResponse);
        ManageFormStore.removeListener('saveFormNameResponse', this.saveFormNameResponse);
        ManageFormStore.removeListener('currFav', this.loadFavPageResponse);
        ManageFormStore.removeListener('insertFav', this.updateFavPageResponse);
        ManageFormStore.removeListener('cloneFormResponse', this.cloneFormResponse);

    }

    cloneFormResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let formDetails = this.state.formDetails
        let originalFormDetails = this.state.originalFormDetails
        let cloneFormResponse = JSON.parse(ManageFormStore.cloneFormResponse);
        let status = cloneFormResponse.status;
        if (status != undefined && status != null) {
            if (status[0] != undefined && status[0] != null) {
                if (status[0].lblerror != null && status[0].lblerror != "" && status[0].lblerror != " ") {
                    if (status[0].lblerror.toLowerCase() == "form saved successfully") {
                        formDetails.map((item, index) => {
                            item.ISEDITCLICK = false;
                            item.ISCLONE = false;
                        })
                        if (originalFormDetails != undefined && originalFormDetails != null) {
                            originalFormDetails.map((item, index) => {
                                item.ISEDITCLICK = false;
                                item.ISCLONE = false;
                            })
                        }
                        $('#successpopup').modal('show');
                        let questions = JSON.parse(JSON.stringify(this.state.questions));
                        let options = JSON.parse(JSON.stringify(this.state.options));
                        let tempQues = JSON.parse(JSON.stringify(this.state.questions));
                        let tempOptions = JSON.parse(JSON.stringify(this.state.options));
                        questions = questions.filter((val, ind) => val.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == this.state.currentForm.toLowerCase().trim().split(/ +/).join(' '));
                        if (questions != undefined && questions != null) {
                            questions.map((val, index) => {
                                val.FORMNAME = this.state.editFormName
                                tempQues.push(val);
                            })
                        }
                        options = options.filter((val, ind) => val.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == this.state.currentForm.toLowerCase().trim().split(/ +/).join(' '));
                        options.map((val, index) => {
                            val.FORMNAME = this.state.editFormName
                            tempOptions.push(val);
                        })
                        this.setState({ formDetails: formDetails, duplicateformDetails: originalFormDetails, questions: tempQues, options: tempOptions })
                    } else {
                        swal({
                            allowOutsideClick: false,
                            closeOnClickOutside: false,
                            text: status[0].lblerror
                        });
                    }
                }
            }
        }
    }

    saveFormNameResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let saveFormNameResponse = JSON.parse(ManageFormStore.saveFormNameResponse);
        let status = saveFormNameResponse.status;
        if (status != undefined && status != null) {
            if (status[0] != undefined && status[0] != null) {
                if (status[0].lblerror != null && status[0].lblerror != "" && status[0].lblerror != " ") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: status[0].lblerror
                    });
                    if (status[0].lblerror.toLowerCase() == "form saved successfully") {
                        let formDetails = this.state.formDetails
                        let quesArray = JSON.parse(JSON.stringify(this.state.questions));
                        let options = this.state.options
                        quesArray.map((item, index) => {
                            if (item.FORMNAME.toLowerCase().trim() == this.state.existingFormName.toLowerCase().trim())
                                item.FORMNAME = formDetails[this.state.editIndex].FORMNAME.toUpperCase();
                        })
                        options.map((item, index) => {
                            if (item.FORMNAME.toLowerCase().trim() == this.state.existingFormName.toLowerCase().trim())
                                item.FORMNAME = formDetails[this.state.editIndex].FORMNAME.toUpperCase();
                        })
                        let originalFormDetails = this.state.originalFormDetails
                        originalFormDetails[this.state.dupIndex + 1].ISEDITCLICK = false
                        formDetails[this.state.editIndex].ISEDITCLICK = false
                        this.setState({ formDetails: formDetails, options: options, questions: quesArray, duplicateformDetails: originalFormDetails })

                    }
                }
            }
        }
    }

    pageLoadResponse = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let pageLoadData = JSON.parse(ManageFormStore.pageLoadResponse);
        let formDetails = pageLoadData.FormDetails;
        let count = parseFloat(formDetails.length) / 10
        let questionArray = JSON.parse(JSON.stringify(pageLoadData.Question));
        let options = pageLoadData.options;
        let errorTable = pageLoadData.ErrorTable;
        if (errorTable != undefined && errorTable != null) {
            if (errorTable[0] != undefined && errorTable[0] != null) {
                if (errorTable[0].lblerror != null && errorTable[0].lblerror != "" && errorTable[0].lblerror != " ") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: errorTable[0].lblerror
                    });
                    if (errorTable[0].lblerror.toLowerCase() != "no records found") {
                        this.props.history.push({
                            pathname: '/',
                        });
                    }
                }
            }
        }
        if (questionArray != undefined && questionArray != null) {
            questionArray.map((item, index) => {
                questionArray[index].ISDELETE = "N";
            })
        }
        if (options != undefined && options != null) {
            options.map((item, index) => {
                options[index].ISDELETE = "N";
            })
        }
        if (formDetails != undefined && formDetails != null) {
            formDetails.map((item, index) => {
                formDetails[index].ISEDITCLICK = false;
                formDetails[index].ISCLONE = false;
            })
        }
        this.setState({ formDetails: formDetails, originalFormDetails: formDetails, questions: questionArray, options: options, duplicateformDetails: formDetails, pageCount: count })
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    deleteFormResponse = () => {
        
        let deleteFormResponse = JSON.parse(ManageFormStore.deleteFormResponse);
        let status = deleteFormResponse.status;
        if (status != undefined && status != null) {
            if (status[0] != undefined && status[0] != null) {
                if (status[0].lblerror != null && status[0].lblerror != "" && status[0].lblerror != " ") {
                    swal({
                        allowOutsideClick: false,
                        closeOnClickOutside: false,
                        text: status[0].lblerror
                    });
                    let successmsg = status[0].lblerror.toString();
                    if (successmsg.toLowerCase().includes('deleted successfully')) {
                        //let ind = this.state.formDetails.findIndex(x => x.FORMNAME.toLowerCase() == this.state.currentForm.toLowerCase())
                        let tempFormDetails = this.state.formDetails;
                        tempFormDetails.splice(this.state.currentFormIndex, 1)
                        let tempDuplicateFormDetails = JSON.parse(JSON.stringify(this.state.duplicateformDetails));
                        let dupIndex = this.state.duplicateformDetails.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == this.state.currentForm.toLowerCase().trim().split(/ +/).join(' '))
                        tempDuplicateFormDetails.splice(dupIndex, 1)
                        this.setState({ formDetails: tempFormDetails, duplicateformDetails: tempDuplicateFormDetails });
                    }
                }

            }
        }
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    pageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        ManageFormAction.pageLoad();
    }
    deleteForm = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let deleteFormBO = {
            formName: this.state.currentForm
        }
        ManageFormAction.deleteForm(deleteFormBO)
    }
    addNewForm = () => {
        this.props.history.push({
            pathname: "/addforms",
            state: { type: "add", name: "Add Form", formName: "", quesArray: [], options: [], formDetail: this.state.formDetails }
        });
    }

    handleSearchTxt = (e) => {
        let val = e.target.value;
        this.setState({ searchval: val })
    }


    clearSearch = () => {
        
        let count = parseFloat(this.state.duplicateformDetails.length) / 10
        let formDetails = JSON.parse(JSON.stringify(this.state.duplicateformDetails));
        this.setState({ isSearch: false, formDetails: formDetails, pageCount: count, pageNo: "1" })
        $(`#searchTxt`).val('')
        this.setState({ searchval: '' })
    }
    viewForm = (e, formname) => {
        e.preventDefault();
        let questions = this.state.questions.filter((val) => val.FORMNAME.toLowerCase().trim() == formname.toLowerCase().trim());
        let options = this.state.options.filter((val) => val.FORMNAME.toLowerCase().trim() == formname.toLowerCase().trim());

        this.props.history.push({
            pathname: "/addforms",
            state: { type: "view", name: "View  Form", formName: formname, quesArray: questions, options: options, formDetail: this.state.formDetails }
        });
    }
    editClick = (val, e, index) => {
        let formDetails = this.state.formDetails
        formDetails[index].ISEDITCLICK = true
        let dupIndex = this.state.duplicateformDetails.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == val.FORMNAME.toLowerCase().trim().split(/ +/).join(' '))
        this.setState({ formDetails: formDetails, existingFormName: val.FORMNAME, editIndex: index, dupIndex: dupIndex - 1 })
    }
    handleCloneClick = (value, e, index) => {
        
        e.preventDefault();
        let cloneDetail = JSON.parse(JSON.stringify(value));
        cloneDetail.FORMNAME = "";
        cloneDetail.ISCLONE = true;
        let dupIndex = this.state.duplicateformDetails.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == value.FORMNAME.toLowerCase().trim().split(/ +/).join(' '))
        let questions = this.state.questions.filter((val) => val.FORMNAME.toLowerCase().trim() == value.FORMNAME.toLowerCase().trim());
        let options = this.state.options.filter((val) => val.FORMNAME.toLowerCase().trim() == value.FORMNAME.toLowerCase().trim());
        this.setState({ cloneIndex: index, cloneQues: questions, cloneOptions: options, cloneDetail: cloneDetail, currentForm: value.FORMNAME, dupIndex: dupIndex })
        $('#clone-confirmation').modal('show');

    }
    cloneConfirmClick = () => {
        
        let formDetails = JSON.parse(JSON.stringify(this.state.formDetails));
        let duplicateformDetails = JSON.parse(JSON.stringify(this.state.duplicateformDetails));
        let ind = this.state.cloneIndex
        formDetails.map((val, index) => {
            if (val.ISCLONE == true) {
                formDetails.splice(index, 1)
                if (index < ind) {
                    ind = ind - 1;
                }
            }
            val.ISEDITCLICK = false
        })
        formDetails.splice(ind + 1, 0, this.state.cloneDetail)
        duplicateformDetails.splice(this.state.dupIndex + 1, 0, this.state.cloneDetail)
        let pageNo = this.state.pageNo
        if (ind != 0) {
            if ((ind + 1) % 10 == 0) {
                pageNo = parseInt(pageNo) + 1
                window.scrollTo(0, 0)
            }
        }
        this.setState({ formDetails: formDetails, pageNo: pageNo, originalFormDetails: duplicateformDetails })
    }
    OnHandleEditChange = (e, index) => {
        let formDetails = JSON.parse(JSON.stringify(this.state.formDetails));
        formDetails[index].FORMNAME = e.target.value
        let originalFormDetails = []
        if (this.state.originalFormDetails != undefined && this.state.originalFormDetails != null) {
            if (this.state.originalFormDetails.length > 0) {
                originalFormDetails = JSON.parse(JSON.stringify(this.state.originalFormDetails));
                originalFormDetails[this.state.dupIndex + 1].FORMNAME = e.target.value
            }
        }
        this.setState({ formDetails: formDetails, editFormName: e.target.value, originalFormDetails: originalFormDetails })
    }
    saveClick = (formDetail, e, index) => {
        if (formDetail.FORMNAME.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Form Name cannot be empty"
            });
            return
        }
        let formDetails = this.state.formDetails.filter((val, ind) => ind != index);
        let nameInd = formDetails.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == this.state.formDetails[index].FORMNAME.toLowerCase().trim().split(/ +/).join(' '))
        if (nameInd > -1) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Form Name already exists"
            });
        }

        else {
            let cloneQues = JSON.parse(JSON.stringify(this.state.cloneQues));
            let cloneOptions = JSON.parse(JSON.stringify(this.state.cloneOptions));
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            if (formDetail.ISCLONE == true) {
                cloneQues.map((val, index) => {
                    val.FORMNAME = formDetail.FORMNAME
                })
                cloneOptions.map((val, index) => {
                    val.FORMNAME = formDetail.FORMNAME
                })
                let cloneFormBO = {
                    question: cloneQues,
                    options: cloneOptions
                }
                ManageFormAction.cloneForm(cloneFormBO);
            } else {
                let saveClickBO = {
                    existingFormName: this.state.existingFormName,
                    currentFormName: this.state.formDetails[index].FORMNAME
                }
                ManageFormAction.saveClick(saveClickBO);
            }
        }
    }
    cancelClick = (val, e, index) => {
        let formDetails = this.state.formDetails
        let dupformDetails = this.state.duplicateformDetails
        let dupIndex = this.state.originalFormDetails.findIndex(item => item.FORMNAME.toLowerCase().trim().split(/ +/).join(' ') == val.FORMNAME.toLowerCase().trim().split(/ +/).join(' '))
        formDetails[index].FORMNAME = dupformDetails[dupIndex].FORMNAME
        if (val.ISEDITCLICK == true) {
            formDetails[index].ISEDITCLICK = false
            dupformDetails[index].ISEDITCLICK = false
        } else if (val.ISCLONE == true) {
            dupformDetails.splice(dupIndex, 1)
            formDetails.splice(index, 1)
        }
        this.setState({ formDetails: formDetails, existingFormName: val.FORMNAME, editIndex: index, dupIndex: dupIndex - 1, duplicateformDetails: dupformDetails })
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Manage Forms",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            ManageFormAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            ManageFormAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(ManageFormStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (ManageFormStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(ManageFormStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(ManageFormStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };





    handleSearch = () => {
        
        let searchTxt = $(`#searchTxt`).val().toLowerCase();
        if (searchTxt.trim() != "") {
            //this.pageLoad(searchTxt);
            let filteredDetail = this.state.duplicateformDetails.filter((val) => val.FORMNAME.toLowerCase().trim().split(/ +/).join(' ').includes(searchTxt.toLowerCase().trim().split(/ +/).join(' ')))
            let originalFormDetails = this.state.formDetails;
            let count = parseFloat(filteredDetail.length) / 10
            this.setState({ formDetails: filteredDetail, pageCount: count, pageNo: "1", originalFormDetails: originalFormDetails, isSearch: true })

        } else {
            this.setState({ isSearch: true })
            let count = parseFloat(this.state.duplicateformDetails.length) / 10
            this.setState({ pageCount: count, formDetails: this.state.duplicateformDetails })
        }


    }
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }
    AnykeyPress(e) {
        if (e.keyCode == 13) {
            this.handleSearch();
        }
    };
    Sorting = (sortBy) => {
        
        let MatGrid = this.state.formDetails;
        if (sortBy == "ASC") {
            MatGrid.sort(function (a, b) {
                var postion1 = a.FORMNAME.toUpperCase();
                var postion2 = b.FORMNAME.toUpperCase();
                return (postion1 > postion2) ? 1 : -1;
            });
        }
        else {
            MatGrid.sort(function (a, b) {
                var postion1 = a.FORMNAME.toUpperCase();
                var postion2 = b.FORMNAME.toUpperCase();
                return (postion1 > postion2) ? -1 : 1;
            });
        }
        this.setState({ formDetails: MatGrid });
    }
    bindForm = () => {
        let formDetails = this.state.formDetails


        return formDetails.map((val, index) => {
            if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                return (
                    (val.ISEDITCLICK == false && val.ISCLONE == false ?
                        <tr style={{ borderBottom: "1px solid lightgrey" }}>
                            <td data-label="Form Name" style={{ wordBreak: "break-all" }} class="grid-pl" ><a href="#" class="hover-theme" onClick={(e) => this.viewForm(e, val.FORMNAME)}>{val.FORMNAME.toUpperCase()}</a></td>
                            <td data-label="No. of Questions" >{val.COUNT}</td>
                            <td data-label="Action" class="justify-content-center text-center text-nowrap grid-pr">
                                <a href="#" class="edit-icon float-none mb-2" data-toggle="modal" data-target="#edit-fav-popup" onClick={(e) => this.editClick(val, e, index)}><img src="images/edit-icon.png" alt="edit icon" title="Edit" /></a>
                                <a href="#" class="delete-icon float-none delete-icon-position d-inline-block" style={{ height: '17px' }} data-toggle="modal" data-target="#Cancel-confirmation" onClick={(e) => this.setState({ currentForm: val.FORMNAME, currentFormIndex: index })}><img src="Images/delete.svg" alt="delete icon" title="Delete" style={{ height: '20px', marginBottom: "6px" }} /></a>
                                <a href="#" onClick={(e) => this.handleCloneClick(val, e, index)}><img className="px-1 mb-2" src="Images/blue-copy-icon.png" alt="Copy" title="Copy" style={{ height: '20px' }} /></a>
                            </td>
                        </tr> :
                        <tr style={{ borderBottom: "1px solid lightgrey" }}>
                            <input type="text" className="form-control grid-pl mt-1" autoFocus maxLength="254" value={val.FORMNAME} onChange={(e) => this.OnHandleEditChange(e, index)} />
                            <td data-label="No. of Questions" >{val.COUNT}</td>
                            <td data-label="Action" class="justify-content-center text-center text-nowrap grid-pr">
                                <img className="px-1 mr-2" src="Images/tick.png" alt="Save" title="Save" style={{ "height": '20px', "borderBottom": "0px solid" }} onClick={(e) => this.saveClick(val, e, index)} />
                                <img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" onClick={(e) => this.cancelClick(val, e, index)} style={{ "height": '20px', "borderBottom": "0px solid" }} />
                            </td>
                        </tr>)
                )
            }
        })
    }
    render() {
        const { t } = this.props;
        let formDetails = this.state.formDetails
        return (
            <div class="container-fluid content-section" style={{ marginTop: "157px" }}>
                <div class="row">
                    { /* <!-- manage forms starts here -->*/}
                    <div class="container-fluid content-margin">
                        <div class="row">
                            <div class="col-md-12 page-heading mb-3">
                                <h5 class="page-title">Manage Forms</h5>
                                <div className="fav-item-maintenance-icon mt-1">
                                    <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                    <label htmlFor="checkbox-OrdStatus">
                                        <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                            <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                <g className="grp7" opacity={0} transform="translate(7 6)">
                                                    <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                    <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                </g>
                                                <g className="grp6" opacity={0} transform="translate(0 28)">
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                </g>
                                                <g className="grp3" opacity={0} transform="translate(52 28)">
                                                    <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                    <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                </g>
                                                <g className="grp2" opacity={0} transform="translate(44 6)">
                                                    <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                    <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp5" opacity={0} transform="translate(14 50)">
                                                    <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp4" opacity={0} transform="translate(35 50)">
                                                    <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                    <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                </g>
                                                <g className="grp1" opacity={0} transform="translate(24)">
                                                    <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                    <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                </g>
                                            </g>
                                        </svg>
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <span class="font-14 font-regular my-0 mb-4">
                                    <span class="info-container pr-1"><img src="images/info-black-icon.svg" alt="Info-icon" /></span>
                                    Please click the form name to view/edit
                                           </span>
                                <div className="input-group dropdown-search float-right order-filter-width col-md-8 pr-0 mt-2 ml-1 formname-search" style={{ width: "375px" }} >

                                    <input type="text" className="form-control newsearchborderright float-right formname-search-field" maxLength="254" value={this.state.searchval} placeholder="Search Form name" aria-label="Text input with dropdown button" id="searchTxt" onChange={(e) => this.handleSearchTxt(e)} onKeyDown={(e) => this.AnykeyPress(e)} />
                                    <span className={this.state.searchval != null && this.state.searchval != undefined && this.state.searchval != "" ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left", "right":"200px" }} onClick={() => this.clearSearch()}></span>
                                    
                                    <div className="input-group-append">
                                        <span className="input-group-text OrderStatus-SrchBar" style={{ height: "34px" }} onClick={this.handleSearch} >
                                            <span className="shopping-search-icon" />
                                        </span>
                                    </div>
                                    <button type="button" class="btn btn-continue float-right mb-3 ml-3" onClick={() => this.addNewForm()}><img src="images/plus-icon-black.svg" alt="plus" class="mr-1" />New Form</button>
                                </div>

                            </div>
                        </div>
                        {formDetails != [] && formDetails != "" && formDetails != undefined && formDetails != null ?
                            <div className="col-md-12 mb-3">
                                <div className="table-responsive">
                                    <table class="table ZEUS_Grid FOM-grid" id="table">
                                        <thead >
                                            <tr class="table-active " >
                                                <th class="grid-pl border-0">Form Name <span className="sort-up1 ml-1 mb-1" onClick={(e) => this.Sorting("ASC")}><img src="Images/sort2.svg" /></span><span className="sort-downt ml-1" onClick={(e) => this.Sorting("DESC")}><img src="Images/sort1.svg" /></span></th>
                                                <th class="border-0">No. of Questions</th>
                                                <th class="text-center grid-pr border-0">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formDetails.length > 0 ? this.bindForm() : null}
                                        </tbody>
                                    </table>
                                </div>
                            </div> :
                            <section className="site-undercontruction container text-center center-panel pt-4">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                </p>
                            </section>}
                        {formDetails != [] && formDetails != "" && formDetails != undefined && formDetails != null ?
                            <div className="col-md-12 ">
                                <span className="total-records mt-2 d-inline-block">
                                    <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{formDetails.length}</span>
                                </span>
                                {formDetails != [] && formDetails != "" && formDetails != undefined && formDetails != null && this.state.pageCount > 1 ? <ReactPaginate
                                    previousLabel={<span className="right-pagination-arrow" />}
                                    nextLabel={<span className="left-pagination-arrow" />}
                                    previousClassName={'page-item'}
                                    nextClassName={'page-item'}
                                    previousLinkClassName={'page-link'}
                                    nextLinkClassName={'page-link'}
                                    disabledClassName={'disabled'}
                                    breakLabel={'...'}
                                    breakClassName={'page-item'}
                                    breakLinkClassName={'page-link'}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={1}
                                    pageRangeDisplayed={2}
                                    onPageChange={e => this.handlePageClick(e)}
                                    containerClassName={'custom-pagination pagination float-right'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                    activeClassName={'active'}
                                    hrefBuilder={() => '#'}
                                    forcePage={this.state.pageNo - 1}
                                /> : null}

                            </div> : null}
                    </div>
                </div>
                <div class="modal" id="Cancel-confirmation">
                    <div class="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div class="modal-content">

                            {/* <!-- Modal Header -->*/}
                            <div class="modal-header">
                                <h4 class="modal-title mt-1"></h4>
                                <button type="button" class="btn close-btn" data-dismiss="modal">
                                    X
                                      </button>
                            </div>

                            {/* / <!-- Modal body --> */}
                            <div class="modal-body">
                                <div class="row text-center">
                                    <div class="col-md-12 my-4">
                                        <span class="question-mark-icon delete-confirm-icon"></span>

                                    </div>


                                    <div class="col-12 mb-4">
                                        <label class="confirm-label d-block">Confirm</label>
                                        <label class="confirm-content d-block">Do you want to delete {this.state.currentForm} ?</label>
                                    </div>


                                    <div class="col-md-12 text-center mb-2">
                                        <button class="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5"
                                            data-dismiss="modal">No</button>
                                        <button class="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.deleteForm()}>Yes</button>
                                    </div>


                                </div>


                            </div>


                        </div>
                    </div>
                </div>
                <div class="modal" id="clone-confirmation">
                    <div class="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div class="modal-content">
                            {/* <!-- Modal Header -->*/}
                            <div class="modal-header">
                                <h4 class="modal-title mt-1"></h4>
                                <button type="button" class="btn close-btn" data-dismiss="modal">
                                    X
                                      </button>
                            </div>

                            {/* / <!-- Modal body --> */}
                            <div class="modal-body">
                                <div class="row text-center">
                                    <div class="col-12 mb-4">
                                        <div className="col-md-12 my-4">
                                            <span className="question-mark-icon" />
                                        </div>
                                        <label class="confirm-label d-block">Confirm</label>

                                        <label class="confirm-content d-block">Do you want to clone {this.state.currentForm} ?</label>
                                    </div>


                                    <div class="col-md-12 text-center mb-2">
                                        <button class="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5"
                                            data-dismiss="modal">No</button>
                                        <button class="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" onClick={() => this.cloneConfirmClick()}>Yes</button>
                                    </div>


                                </div>
                            </div>


                        </div>
                    </div>
                </div>
                <div className="modal" id="successpopup" >
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">c                         <div className="modal-content">
                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row justify-content-center">
                                <div className="col-md-12">
                                    <div className="text-center my-4">
                                        <span className="info-label d-block">Form saved successfully.</span>
                                        <span className="info-label d-block">Cloned form will be available on the current page now.</span>
                                        <span className="info-label">On page refresh, it will be sorted alphabetically</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 text-center mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal">OK</button>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                {/* <!-- edit forms ends here -->*/}
            </div>
        );
    }

} export default withTranslation()(ManageFormComponent);